let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ei01l")).then(() => parcelRequire('kZnjh'));